<template lang="html">
<div>
    <div class="inner-page" :style="'height:' + pageH + 'px;'">
        <Header>找回密码</Header>
        <div class="pcode-text">
            <div class="inpGroup">
                 <div class="inp-inner">
                      <div class="inp-icons">
                        <van-icon class="icon" class-prefix="iconfont" name="user" />
                        <span>+86</span>
                      </div>
                      <input v-model="uPhone" placeholder="请输入手机号" type="text" maxlength="11">
                 </div>
            </div>
            <div class="imgCode">
                 <div class="imgContent" @click="codeChange">
                      <img :src="imgUrl">
                 </div>
                 <div class="inp-inner">
                      <input v-model="imgCode" placeholder="请输入验证码" type="text" maxlength="4">
                 </div>
            </div>
            <div class="inpGroup">
                 <div class="inp-inner">
                      <div class="inp-icons">
                         <van-icon class="icon" class-prefix="iconfont" name="pswd" />
                      </div>
                      <input v-model="uPasscode" placeholder="请输入新密码" type="text" maxlength="11">
                 </div>
            </div>
        </div>

        <div @click="imgCodeFirm" :class="['smt-btn',{'act':canFirm}]">发送手机验证码</div>
    </div>
</div>
</template>

<script>
import { imgCodeFirm,phoneCode } from "@/api/login";
export default {
    computed:{
        canFirm:function(){
            let phones = /^1[3|4|5|7|8][0-9]{9}$/;
            let imgcode = /[0-9][A-z]{4}/;
            let passcode = /^[0-9A-z]{6,18}$/;
            let cans = phones.test(this.uPhone) && imgcode.test(this.imgCode);
            return cans;
        }
    },
    data(){
         return{
            uPhone:'',
            imgCode:'',
            uPasscode:'',
            imgUrl:'/User/User/getVerifyImg',
            pageH:''
         }
    },
    methods:{
         imgCodeFirm:function(){
             this.push({
                 path:'codefirm',
                 query:{
                      uPhone:this.uPhone,
                      uPasscode:this.uPasscode
                 }
             });
             if(this.canFirm){
                  let vues = this;
                  imgCodeFirm({
                       type:2,
                       cellphone:this.uPhone,
                       imgCode:this.imgCode
                  }).then(res => {
                       phoneCode({
                           type:2,
                           cellphone:this.uPhone,
                           imgCode:this.imgCode
                       }).then(res2 => {
                           vues.$router.push({
                                path:'codefirm',
                                query:{
                                     cellphone:this.uPhone
                                }
                           })
                       }).catch(errs => {

                       })
                  }).catch(errs => {
                       this.codeChange();
                  })
             }
         },

         codeChange:function(){
             this.imgUrl = '/User/User/getVerifyImg?newCode=' + Date.parse(new Date());
         }
    },
    created:function(){
         this.pageH = document.documentElement.clientHeight;
    }
}
</script>

<style lang="css" scoped>

.inner-page{
  background: white;
}

/* 输入 */

.pcode-text{
    margin-top: 50px;
}

.inpGroup{
    margin-top: 18px;
}

.inp-inner{
    width: 300px;
    height: 42px;
    margin: 0 auto;
    border: 1px solid #999999;
    border-radius: 3px;
    display: flex;
    align-items: center;
}

.imgCode{
    width: 300px;
    height: 42px;
    display: flex;
    margin: 0 auto;
    margin-top: 18px;
}

.imgContent{
    width: 90px;
    height: 42px;
    border: 1px solid #999999;
    border-radius: 3px;
    flex-shrink: 0;
    background: #f8f8f8;
}

.imgContent img{
    width: 90px;
    height: 42px;
}

.imgCode .inp-inner{
    flex-grow: 1;
    margin-left: 9px;
}

.inp-icons{
    margin: 0 9px;
    text-align: center;
}

.inp-icons .icon{
    font-size: 21px;
    display: inline-block;
    vertical-align: middle;
    color: #af2d2d;
}

.inp-icons span{
   display: inline-block;
   vertical-align: middle;
   font-size: 15px;
}

.inp-inner input{
    height: 36px;
    border: none;
    width: 210px;
    color: #666666;
    font-size: 14px;
    background: transparent;
}

.imgCode .inp-inner input{
    width: 180px;
    margin: 0 auto;
    background: transparent;
}


.subText{
    width: 300px;
    margin: 0 auto;
    text-align: right;
    margin-top: 12px;
}

.subText span{
    font-size: 14px;
    color: #999999;
}

.smt-btn{
    width: 300px;
    height: 42px;
    font-size: 15px;
    letter-spacing: 0.72px;
    line-height: 42px;
    text-align: center;
    background: #999999;
    margin: 0 auto;
    margin-top: 60px;
    color: white;
    border-radius: 3px;
    box-shadow: 0px 3px 6px #999999;
}

.smt-btn.act{
    background: #af2d2d;
}

</style>
